"use strict";
/** Схемы собственного профиля. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.changePasswordSchema = exports.updateProfileSchema = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
/**
 * Пустая строка равна «не заполнено».
 *
 * Человек стирает поле, чтобы убрать сведения, а не чтобы записать туда
 * пустоту. Без этого преобразования в базе копились бы пустые строки,
 * которые интерфейсу пришлось бы отличать от null в каждом месте показа.
 */
const optionalText = (max, tooLong) => zod_1.z
    .string()
    .trim()
    .max(max, tooLong)
    .transform((value) => value || null)
    .nullish();
exports.updateProfileSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(2, 'Имя не короче двух символов').max(200, 'Имя слишком длинное'),
    title: optionalText(160, 'Не длиннее 160 символов'),
    location: optionalText(120, 'Не длиннее 120 символов'),
    contact: optionalText(200, 'Не длиннее 200 символов'),
    bio: optionalText(400, 'Не длиннее 400 символов'),
});
/**
 * Смена пароля.
 *
 * Текущий пароль обязателен даже при действующей сессии: чужой
 * незаблокированный ноутбук не должен превращаться в захват учётной записи.
 */
exports.changePasswordSchema = zod_1.z
    .object({
    currentPassword: zod_1.z.string().min(1, 'Введите текущий пароль'),
    newPassword: common_1.passwordSchema,
    newPasswordConfirmation: zod_1.z.string(),
})
    .refine((value) => value.newPassword === value.newPasswordConfirmation, {
    message: 'Пароли не совпадают',
    path: ['newPasswordConfirmation'],
});
//# sourceMappingURL=profile.js.map